// extracted by mini-css-extract-plugin
export default {"root":"nk40V","label":"_3U9ow","value":"_3WgsI"};